import script from "./MenuConfirmation.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuConfirmation.vue?vue&type=script&setup=true&lang=js"

import "./MenuConfirmation.vue?vue&type=style&index=0&id=7066f4fa&lang=scss"

const __exports__ = script;

export default __exports__